import { render, staticRenderFns } from "./NewCustomField.vue?vue&type=template&id=14361cec&"
import script from "./NewCustomField.vue?vue&type=script&lang=js&"
export * from "./NewCustomField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports